import React from "react";
import { motion } from "framer-motion";
import { BookOpen, FileText, ClipboardCheck, Layers } from "lucide-react";
import "./StudyMaterial.module.css";

const MaterialCard = ({ Icon, title, description, color }) => (
    <motion.div
        className="material-card bg-white rounded-lg shadow-md p-6 flex flex-col items-center text-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg hover:border hover:border-primary"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        whileHover={{ scale: 1.05 }}
    >
        <motion.div className="mb-4 overflow-hidden rounded-md">
            <Icon className={`w-16 h-16 ${color}`} />
        </motion.div>
        <h3 className="text-xl font-semibold mb-2 transition-colors duration-300 hover:text-primary">{title}</h3>
        <p className="text-gray-600 text-sm">{description}</p>
    </motion.div>
);

const StudyMaterial = () => {
    const materials = [
        {
            Icon: BookOpen,
            color: "text-blue-400 bg-blue-100 py-3",
            title: "Books & Notes",
            description: "Expertly Curated Notes and Books for Practice and Preparation",
        },
        {
            Icon: FileText,
            color: "text-red-400 bg-red-100 py-3",
            title: "Handouts",
            description: "Handout of Most Updated Study Material to Supplement Classes",
        },
        {
            Icon: ClipboardCheck,
            color: "text-green-400 bg-green-100 py-3", 
            title: "Daily Updates",
            description: "Regular Updates Regarding Current Affairs Exam Trends and Much More on our Website",
        },
        {
            Icon: Layers,
            color: "text-yellow-400 bg-yellow-100 py-3",
            title: "Tests & Evaluation",
            description: "Well Planned Mock Tests and Evaluation to Test Your Preparation",
        },
    ];

    return (
        <div className="bg-white py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                <motion.h2 className="text-3xl font-bold text-center mb-4" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
                    <span className="text-[#4267B2]">Study</span> Material
                </motion.h2>
                <motion.p
                    className="text-center text-gray-700 mb-12 max-w-2xl mx-auto"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.3 }}
                >
                    From Quick Books to Mock Tests, Find Everything You Need to Succeed in One Place.
                </motion.p>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {materials.map((material, index) => (
                        <MaterialCard key={index} {...material} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StudyMaterial;
